<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_metadata_type') || '属性类型'"
            prop="metadataType"
          >
            <el-input
              clearable
              v-model="formData.metadataType"
              :placeholder="
                $l('form_label_pe_metadata_type') || '请输入属性类型'
              "
              :disabled="metadataTypeDisabled"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_metadata_name') || '属性名称'"
            prop="metadataName"
          >
            <el-input
              clearable
              v-model="formData.metadataName"
              :placeholder="
                $l('form_label_pe_metadata_name') || '请输入属性名称'
              "
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row> </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_metadata_name_en') || '属性名称英文'"
            prop="metadataNameEn"
          >
            <el-input
              clearable
              v-model="formData.metadataNameEn"
              :placeholder="
                $l('form_label_pe_metadata_name_en') || '请输入属性名称英文'
              "
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_status') || '有效状态'"
            prop="metadataStatus"
          >
            <br />
            <el-radio-group v-model="formData.metadataStatus">
              <el-radio label="Y">{{
                $l('INDEX.form_label_valid') || '有效'
              }}</el-radio>
              <el-radio label="N">{{
                $l('INDEX.form_label_invalid') || '无效'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean, //如果为detail模式则禁用表单
    metadataCode: String
  },
  components: {},
  data() {
    return {
      metadataTypeDisabled:
        this.metadataCode !== undefined && this.metadataCode != '',
      formData: {
        metadataStatus: 'Y'
      },
      rules: {
        metadataType: [
          {
            required: true,
            message: this.$l('form_label_pe_metadata_type') || '请输入属性类型',
            trigger: 'blur'
          }
        ],
        metadataName: [
          {
            required: true,
            message: this.$l('form_label_pe_metadata_name') || '请输入属性名称',
            trigger: 'blur'
          }
        ],
        metadataNameEn: [
          {
            required: true,
            message:
              this.$l('form_label_pe_metadata_name_en') || '请输入属性名称英文',
            trigger: 'blur'
          }
        ],
        metadataStatus: [
          { required: true, message: '请选择有效状态', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.getDate()
  },
  methods: {
    getDate() {
      if (!this.metadataCode) return
      this.$api
        .sampleMetadataDetailApi({
          metadataCode: this.metadataCode
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .sampleMetadataSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success'
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存'
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    }
  }
}
</script>
